export { default } from './TabScrollButton';